import { render, staticRenderFns } from "./SocketCommStatusDetail.vue?vue&type=template&id=a685413c&scoped=true"
import script from "./SocketCommStatusDetail.vue?vue&type=script&lang=js"
export * from "./SocketCommStatusDetail.vue?vue&type=script&lang=js"
import style0 from "./SocketCommStatusDetail.vue?vue&type=style&index=0&id=a685413c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a685413c",
  null
  
)

export default component.exports